// removed by extract-text-webpack-plugin
module.exports = {"container":"_20JEo","avatar":"_3n8YU","column1":"_3FSAm","column2":"_9acGw","column3":"_2m6cG","message":"_15wu7","timeAgo":"_2scSD","dot":"qVu7G"};


//////////////////
// WEBPACK FOOTER
// ./app/components/notification-list-item/notification-list-item.scss
// module id = 1327
// module chunks = 0